import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from './Loading'; // Import the Loading component
import './PrivateRoute.scss';

const PrivateRoute = ({ requiredPermissions }) => {
  const { isAuthenticated, userPermissions, loading } = useAuth();

  console.log('PrivateRoute:', { isAuthenticated, userPermissions, requiredPermissions });

  if (loading) {
    return <Loading />; // Use the Loading component instead of "Loading..."
  }

  const hasRequiredPermissions = requiredPermissions.every(permission =>
    userPermissions.includes(permission)
  );

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to /signin');
    return <Navigate to="/signin" />;
  }

  if (!hasRequiredPermissions) {
    console.log('Missing required permissions, redirecting to /unauthorized');
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
